import * as React from 'react';
import { useLocale, useTranslations } from '@accenturecodefoundry/mfe-pot-shared-i18n';
import { assetBaseUrl } from '../asset-base-url';
import './SupportRow.css';

export interface SupportRowProps {
  iconName: string;
  titleKey: string;
  bodyKey: string;
  href: string;
}

/**
 * A full-row clickable support link: navy icon well + heading + body text + trailing chevron.
 * Matches the support/resource row pattern in OverviewScreen.tsx (design1 `src` variant).
 * Self-serves locale/translations, same convention as every other kit component.
 */
export function SupportRow({ iconName, titleKey, bodyKey, href }: SupportRowProps) {
  const locale = useLocale();
  const { t } = useTranslations(assetBaseUrl, locale);

  return (
    <a href={href} className="support-row">
      <div aria-hidden="true" className="support-row__icon-well">
        <scds-icon name={iconName} size="md" />
      </div>
      <div className="support-row__text">
        <span className="support-row__title">{t(titleKey)}</span>
        <span className="support-row__body">{t(bodyKey)}</span>
      </div>
      <scds-icon name="chevron-right" size="md" aria-hidden="true" className="support-row__chevron" />
    </a>
  );
}
